// src/features/employees/components/EmployeeForm.tsx

import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from '@/hooks/use-toast';
import { employeeSchema } from '../schemas/employee.schema';
import { EmployeeFormData } from '../types/employee.types';
import { useCreateEmployee } from '../hooks/useCreateEmployee';

const EmployeeForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<EmployeeFormData>({
    resolver: zodResolver(employeeSchema),
  });

  const { mutateAsync } = useCreateEmployee();

  const onSubmit = async (data: EmployeeFormData) => {
    try {
      await mutateAsync(data);
      toast({
        title: 'Empleado creado',
        description: 'El empleado fue registrado correctamente.',
      });
      reset();
    } catch (error: any) {
      toast({
        title: 'Error al crear empleado',
        description:
          error?.response?.data?.message || 'No se pudo crear el empleado.',
        variant: 'destructive',
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 max-w-md">
      <div>
        <Label htmlFor="username">Nombre de usuario</Label>
        <Input id="username" {...register('username')} />
        {errors.username && (
          <p className="text-sm text-red-600">{errors.username.message}</p>
        )}
      </div>

      <div>
        <Label htmlFor="password">Contraseña</Label>
        <Input id="password" type="password" {...register('password')} />
        {errors.password && (
          <p className="text-sm text-red-600">{errors.password.message}</p>
        )}
      </div>

      <div>
        <Label htmlFor="card_id">ID de tarjeta</Label>
        <Input id="card_id" {...register('card_id')} />
        {errors.card_id && (
          <p className="text-sm text-red-600">{errors.card_id.message}</p>
        )}
      </div>

      <Button type="submit" disabled={isSubmitting}>
        Crear empleado
      </Button>
    </form>
  );
};

export default EmployeeForm;
